import { NEW_PASSWORD_MIN_LENGTH, language } from "@chef/constants";

export const intl = (
  {
    no: {
      PASSWORD: "Passord",
      NEW_PASSWORD: "Nytt passord",
      CONFIRM_NEW_PASSWORD: "Gjenta nytt passord",
      CANCEL_BUTTON_TEXT: "Avbryt",
      SUBMIT_BUTTON_TEXT: "Lagre endring",

      PASSWORD_MUST_BE_MIN_CHARACTERS: `Passordet må være på minst ${NEW_PASSWORD_MIN_LENGTH} tegn`,
      PASSWORDS_MUST_MATCH: "Passordene må være like",
    },

    se: {
      PASSWORD: "Lösenord",
      NEW_PASSWORD: "Nytt lösenord",
      CONFIRM_NEW_PASSWORD: "Bekräfta nytt lösenord",
      CANCEL_BUTTON_TEXT: "Avbryt",
      SUBMIT_BUTTON_TEXT: "Spara ändring",

      PASSWORD_MUST_BE_MIN_CHARACTERS: `Ange ett nytt lösenord som innehåller minst ${NEW_PASSWORD_MIN_LENGTH} tecken`,
      PASSWORDS_MUST_MATCH: "Lösenord överensstämmer inte",
    },

    dk: {
      PASSWORD: "Kodeord",
      NEW_PASSWORD: "Nyt kodeord",
      CONFIRM_NEW_PASSWORD: "Bekræft nyt kodeord",
      CANCEL_BUTTON_TEXT: "Annuller",
      SUBMIT_BUTTON_TEXT: "Gem ændring",

      PASSWORD_MUST_BE_MIN_CHARACTERS: `Kodeordet skal være mindst ${NEW_PASSWORD_MIN_LENGTH} tegn`,
      PASSWORDS_MUST_MATCH: "Kodeordene skal være ens",
    },
  } as const
)[language];
